import { Tooltip } from '@chakra-ui/react';

// Workaround for Tooltip not supporting default props in ComponentStyleConfig
// https://github.com/chakra-ui/chakra-ui/issues/3347#issuecomment-778043220
Tooltip.defaultProps = {
  openDelay: 300,
};

export { Tooltip };
